export const isValidEmail = (text: string | undefined): boolean => {
  if (!text) {
    return false;
  }
  const result =
    text && text.length > 0 && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(text);
  return !!result;
};
